import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useHttp from '../../hooks/http.hook';
import '../business/Business.css';
import CreateBusinessHeader from '../business/components/CreateBusinessHeader';
import CreateFooter from '../business/components/CreateFooter';

function UpsertCategory() {
  const navigate = useNavigate();
  const location = useLocation();
  const { categoryId } = useParams();
  const isEdit = !!categoryId;

  const { loading, requestWithMeta } = useHttp();

  const [name, setName] = React.useState('');
  const [submitError, setSubmitError] = React.useState(null);
  const [isPrefillLoading, setIsPrefillLoading] = React.useState(false);

  React.useEffect(() => {
    let cancelled = false;
    if (!isEdit) return;

    setSubmitError(null);

    async function prefill() {
      setIsPrefillLoading(true);
      try {
        const stateCategory = location?.state?.category ?? null;
        const stateId = stateCategory?.id ?? stateCategory?._id ?? null;
        if (stateCategory && stateId && String(stateId) === String(categoryId)) {
          if (cancelled) return;
          setName(stateCategory?.name ?? '');
          return;
        }

        const res = await requestWithMeta(
          `/operator/categories/${encodeURIComponent(categoryId)}`,
          'GET'
        );
        if (!res?.ok) {
          if (cancelled) return;
          setSubmitError(res?.data?.error || res?.data?.message || 'Не удалось загрузить категорию');
          return;
        }

        const category = res?.data?.category ?? null;
        if (!category) {
          if (cancelled) return;
          setSubmitError('Категория не найдена');
          return;
        }

        if (cancelled) return;
        setName(category?.name ?? '');
      } finally {
        if (!cancelled) setIsPrefillLoading(false);
      }
    }

    prefill();
    return () => {
      cancelled = true;
    };
  }, [isEdit, categoryId, location?.state, requestWithMeta]);

  const isSubmitDisabled = loading || isPrefillLoading || name.trim().length === 0;

  async function handleSubmit() {
    setSubmitError(null);
    const trimmedName = name.trim();
    if (!trimmedName) {
      setSubmitError('Введите название категории');
      return;
    }

    if (isEdit) {
      const res = await requestWithMeta(
        `/operator/categories/${encodeURIComponent(categoryId)}`,
        'PUT',
        { name: trimmedName }
      );
      if (!res?.ok) {
        setSubmitError(res?.data?.error || res?.data?.message || 'Не удалось обновить категорию');
        return;
      }
      navigate('/categories', { replace: true });
      return;
    }

    const res = await requestWithMeta('/operator/categories', 'POST', { name: trimmedName });
    if (!res?.ok) {
      setSubmitError(res?.data?.error || res?.data?.message || 'Не удалось создать категорию');
      return;
    }

    navigate('/categories', { replace: true });
  }

  return (
    <div className="shop-create-root">
      <div className="shop-create-mobile">
        <CreateBusinessHeader
          title={isEdit ? 'Редактировать категорию' : 'Новая категория'}
          subtitle={isEdit ? 'Измените название категории' : 'Введите название новой категории'}
          onBack={() => navigate('/categories')}
        />

        <main className="shop-create-content">
          {submitError ? (
            <section className="shop-create-section shop-create-sectionError">
              <div className="shop-create-label">Ошибка</div>
              <div className="shop-create-help shop-create-helpTight">{submitError}</div>
            </section>
          ) : null}

          <section className="shop-create-section">
            <label className="shop-create-label" htmlFor="category-name">
              Название категории <b style={{ color: 'red' }}>*</b>
            </label>
            <input
              id="category-name"
              className="shop-create-input"
              placeholder="например, Напитки"
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoComplete="off"
              disabled={isPrefillLoading}
            />
          </section>
        </main>

        <CreateFooter
          disabled={isSubmitDisabled}
          label={
            loading
              ? isEdit
                ? 'Сохранение…'
                : 'Создание…'
              : isEdit
                ? 'Сохранить'
                : 'Создать категорию'
          }
          onCreate={handleSubmit}
        />
      </div>
    </div>
  );
}

export default UpsertCategory;
